/**
 * Act as a wrapper to the global communication object to deliver promises for more manageable asynchronous calls.
 */

var VRC = VRC || {};

VRC.CommunicationService = (function () {
	var _service;

	/**
	 * Initializes the service
	 * @param globalService the global communation object.
	 */
	var init = function (globalService) {
		_service = globalService;
	};

	/**
	 * Creates generig handler
	 * @returns {{deferred: *, onSuccess: Function, onError: Function}}
	 */
	var createDeferredHandler = function () {
		var deferred = $.Deferred();

		var onSuccess = function (self, data) {
			VRC.LoadingModal.hide();
			deferred.resolve(self, data);
		};
		var onError = function (data) {
			VRC.LoadingModal.hide();
			deferred.reject(data);
		};

		return {
			deferred: deferred,
			onSuccess: onSuccess,
			onError: onError
		};
	};

	/**
	 * Fetches data from server
	 * @param owner The element that sends the request
	 * @param fetchType type of fetch: 'bulk_tanks', 'bulk_data'
	 * @param (optional) parameters.
	 * @returns promise resolved in FetchDataFromServer.
	 */
	var fetchData = function (owner, fetchType, params) {
		params = params || '';
		var def = createDeferredHandler();
		_service.FetchDataFromServer(owner, def.onSuccess, fetchType, params, def.onError);
		return def.deferred.promise();
	};

	/**
	 * Fetches masterdata from server
	 * @param owner The element that sends the request
	 * @returns promise resolved in FetchMasterData.
	 */
	var fetchMasterData = function (owner) {
		var def = createDeferredHandler();
		_service.FetchMasterData(owner, def.onSuccess, def.onError);
		return def.deferred.promise();
	};

	/**
	 * Fetches masterdata2 from server
	 * @param owner The element that sends the request
	 * @returns promise resolved in FetchMasterData2.
	 */
	var fetchMasterData2 = function (owner) {
		var def = createDeferredHandler();
		_service.FetchMasterData2(owner, def.onSuccess, def.onError);
		return def.deferred.promise();
	};

	/**
	 * Fetches Bulk Cargo Request from server
	 * @param portId portId
	 * @returns promise resolved in FetchMasterData.
	 */
	var getBulkCargoRequests = function (portId) {
		var params = {"port": portId, "ver": GetVersionNumber()};
		return fetchData({}, 'bulk_transit', params);
	};

	/**
	 * Submitting Data
	 * @param submitCode What to be submitted ['all', 'all_no_deck', 'deck']
	 * @param suppressMessage (boolean) should Infomessage be sent?
	 * @param showLoading (boolean) should Loading modal be showmn?
	 * @returns {*}
	 */
	var submitData = function (submitCode, suppressMessage, showLoading) {
		if (showLoading === undefined) {
			showLoading = true;
		}
		if (showLoading) {
			VRC.LoadingModal.show();
		}

		submitCode = submitCode || 'all';
		suppressMessage = suppressMessage || true;
		var def = createDeferredHandler();
		_service.SubmitAllData(submitCode, def.onSuccess, def.onError, suppressMessage)
		return def.deferred.promise();
	};

	return {
		init: init,
		fetchData: fetchData,
		fetchMasterData: fetchMasterData,
		fetchMasterData2: fetchMasterData2,
		getBulkCargoRequests: getBulkCargoRequests,
		submitData: submitData
	}

})();